import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as n } from "../../../../IconBase-CxZyIWw2.js";
const s = i((e, r) => /* @__PURE__ */ o.jsx(
  n,
  {
    ref: r,
    ...e,
    image: (l) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M8.586 8 5.793 5.207l1.414-1.414 3.5 3.5a1 1 0 0 1 0 1.414l-3.5 3.5-1.414-1.414z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "ChevronIcon";
export {
  s as ChevronIcon,
  s as default
};
//# sourceMappingURL=index.js.map
